<script lang="ts">
    import {onMount} from "svelte";
    import {t} from "i18next";

    import {initI18n} from "@services/i18nService";
    import NavBar from "@components/NavBar.svelte";
    import Footer from "@components/Footer.svelte";
    import Game from "@components/GameLoader.svelte";
    import {metaContext} from "@src/appStore";

    onMount(initialize);

    function initialize() {
        console.log("init app.svelte");

        initI18n().then(() => {
            console.log("init i18n");
            metaContext.set(window.metaContext);
            setMetadata();
            clearLoadingState();
            document.querySelector("body")?.classList?.remove("loading");
        })
    }

    function clearLoadingState() {
        document.querySelector("body")?.classList?.remove("loading");
        document.getElementById("lds-ring")?.remove();
    }

    function setMetadata() {
        document.title = `Super Sloth | ${t("play_free")} 🦥`;
    }

</script>

{#if $metaContext}
    <NavBar/>
    <Game/>
    <Footer/>
{/if}



<style lang="scss">
  @use "scss/reset";
</style>